import axios from 'axios';

export function verifyEmailDomain(domainId) {
  return axios
    .put(`/api/?entity=vessel&action=verifyEmailDomain&domainId=${domainId}`)
    .then(response => response.data && response.data.data);
}
